const TABS = [
  { id: 'pending',   label: 'Pending',   icon: 'bi-hourglass-split',   variant: 'warning' },
  { id: 'active',    label: 'Active',    icon: 'bi-person-check-fill', variant: 'success' },
  { id: 'suspended', label: 'Suspended', icon: 'bi-person-x-fill',     variant: 'danger'  },
];

function UserTabBar({ activeTab, onTabChange, counts }) {
  return (
    <div className="um-tab-row">
      {TABS.map(tab => (
        <button
          key={tab.id}
          className={`um-tab-btn ${activeTab === tab.id ? 'um-tab-btn--active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          <i className={`bi ${tab.icon} me-2`}></i>
          {tab.label}
          {counts[tab.id] > 0 && (
            <span className={`um-tab-count ms-2 um-tab-count--${tab.variant}`}>
              {counts[tab.id]}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}

export default UserTabBar;
